import "./BottomBox.scss";
import cupcake from "../../assets/images/cupcake.jpg";

const BottomBox = () => {
  return (
    <div className="bottom-box">
      <img src={cupcake} alt="home" className="bottom-box__img" />
      <div className="bottom-box__container">
        <h1 className="bottom-box__title">Who?</h1>
        <p className="bottom-box__text">
          Suddenly I was baking all the time and for any occassion. People
          started to tell me my baking came out of no where so I came up with
          the name Low Key Bakerr.
        </p>
      </div>
    </div>
  );
};

export default BottomBox;
